import { useDataGrid } from '@refinedev/mui';
import { getDefaultFilter, HttpError } from '@refinedev/core';
import { StudyListItem } from '@aphp-ema/common/study';
import { useStudyListColumns } from '../components/StudyListColumns';

export type StudySearchFilters = {
  name?: string;
  contactName?: string;
  status?: string;
  categoryId?: string;
};

export const useStudiesList = () => {
  const { dataGridProps, search, filters } = useDataGrid<
    StudyListItem,
    HttpError,
    StudySearchFilters
  >({
    resource: 'admin/studies',
    onSearch: (searchParams) => {
      const searchFilters = [];

      if (searchParams.name !== undefined && searchParams.name.length > 0) {
        searchFilters.push({
          field: 'name',
          operator: 'contains' as const,
          value: searchParams.name,
        });
      }

      if (
        searchParams.contactName !== undefined &&
        searchParams.contactName.length > 0
      ) {
        searchFilters.push({
          field: 'contactName',
          operator: 'contains' as const,
          value: searchParams.contactName,
        });
      }

      if (searchParams.status !== undefined && searchParams.status.length > 0) {
        searchFilters.push({
          field: 'status',
          operator: 'eq' as const,
          value: searchParams.status,
        });
      }

      if (
        searchParams.categoryId !== undefined &&
        searchParams.categoryId.length > 0
      ) {
        searchFilters.push({
          field: 'categoryId',
          operator: 'eq' as const,
          value: searchParams.categoryId,
        });
      }

      return searchFilters;
    },
  });

  const columns = useStudyListColumns();
  const defaultFilters: StudySearchFilters = {
    name: getDefaultFilter('name', filters, 'contains')?.toString(),
    contactName: getDefaultFilter(
      'contactName',
      filters,
      'contains',
    )?.toString(),
    status: getDefaultFilter('status', filters, 'eq')?.toString(),
    categoryId: getDefaultFilter('categoryId', filters, 'eq')?.toString(),
  };

  return {
    dataGridProps,
    search,
    defaultFilters,
    columns,
  };
};
